module.exports = __webpack_public_path__ + "static/img/SM.3e65ae7d.png";